import { render, staticRenderFns } from "./FeedbackModalQuestion.vue?vue&type=template&id=2a3d05f4&scoped=true&"
import script from "./FeedbackModalQuestion.vue?vue&type=script&lang=js&"
export * from "./FeedbackModalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackModalQuestion.vue?vue&type=style&index=0&id=2a3d05f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d05f4",
  null
  
)

/* custom blocks */
import block0 from "./FeedbackModalQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3d05f4')) {
      api.createRecord('2a3d05f4', component.options)
    } else {
      api.reload('2a3d05f4', component.options)
    }
    module.hot.accept("./FeedbackModalQuestion.vue?vue&type=template&id=2a3d05f4&scoped=true&", function () {
      api.rerender('2a3d05f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FeedbackModalQuestion.vue"
export default component.exports